import { IOrderConfirmation } from "../interfaces/order-confirmation";
import { IOrderConfirmationState } from "../interfaces/order-confirmation-state";

export const ordersConfirmationInitState: IOrderConfirmationState = {
    order: {} as IOrderConfirmation,
    isLoading: false,
    displayPage: null,
    error: '',
};
